<template>
    <div class="modal-backdrop">
        <div class="modal">
            <div class="modal-header">
                <h3>信息</h3>
                <i class="opus_col" @click="closeSelf"></i>
            </div>
            <div class="modal-body">
                <div class="container">
                    <div class="search-box">
                        <input v-model="searchKey" type="search" id="search">
                        <button @click="searchByHand">搜索</button>
                        <div class="tip-box" id="searchTip"></div>
                    </div>
                    <el-amap class="amap-box" :amap-manager="amapManager" :vid="'amap-vue'" :zoom="zoom" :plugin="plugin"
                        :center="[lng,lat]" :events="events" v-if="show">
                        <!-- 标记 -->
                        <el-amap-marker v-for="(marker, index) in markers" :position="marker" :key="index"></el-amap-marker>
                    </el-amap>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn-confirm" @click="confirm">确认</button>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
        </div>
    </div>
</template>
<script>
    import {
        AMapManager,
        lazyAMapApiLoaderInstance
    } from 'vue-amap'
    export default {
        data() {
            let self = this
            return {
                loadover:false,
                address: null,
                searchKey: '',
                amapManager:false,
                markers: [],
                searchOption: {
                    city: '全国',
                    citylimit: true
                },
                zoom: 17,
                lng: 0,
                lat: 0,
                loaded: false,
                events: {
                    init() {
                        lazyAMapApiLoaderInstance.load().then(() => {
                            self.markers = [];
                            if(self.lng!=0){
                                self.markers.push([self.lng,self.lat])
                            }
                            self.initSearch()
                        })
                    },
                    // 点击获取地址的数据
                    click(e) {
                        console.log(e)
                        self.markers = []
                        let {
                            lng,
                            lat
                        } = e.lnglat
                        self.lng = lng
                        self.lat = lat
                        self.markers.push([lng, lat])
                        // 这里通过高德 SDK 完成。
                        let geocoder = new AMap.Geocoder({
                            radius: 1000,
                            extensions: 'all'
                        })
                        geocoder.getAddress([lng, lat], function(status, result) {
                            if (status === 'complete' && result.info === 'OK') {
                                if (result && result.regeocode) {
                                    console.log(result.regeocode.formattedAddress)
                                    self.address = result.regeocode.formattedAddress
                                    self.searchKey = result.regeocode.formattedAddress
                                    self.$nextTick()
                                }
                            }
                        })
                    }
                },
                // 一些工具插件
                plugin: [{
                        // 定位
                        pName: 'Geolocation',
                        events: {
                            init(o) {
                                // o是高德地图定位插件实例
                                //getCurrentPosition定位有时会失败现在改成getCityInfo
                                //getCurrentPosition调用的是result.position
                                o.getCityInfo((status, result) => {
                                    if (result && result.center) {
                                        // 设置经度维度
                                        if(self.lng == 0 && self.lat == 0){
                                            self.lng = result.center[0]
                                            self.lat = result.center[1]
                                        }
                                        // 设置坐标
                                        // self.markers.push()
                                        // self.markers = [[self.lng, self.lat]]
                                        //插入搜索框信息等
                                        // load
                                        self.loaded = true
                                        // 页面渲染好后
                                        self.$nextTick()
                                    }
                                })
                            }
                        }
                    },
                    {
                        // 工具栏
                        pName: 'ToolBar',
                        events: {
                            init(instance) {
                                // console.log(instance);
                            }
                        }
                    },
                    {
                        // 鹰眼
                        pName: 'OverView',
                        events: {
                            init(instance) {
                                // console.log(instance);
                            }
                        }
                    },
                    {
                        // 地图类型
                        pName: 'MapType',
                        defaultType: 0,
                        events: {
                            init(instance) {
                                // console.log(instance);
                            }
                        }
                    },
                    {
                        // 搜索
                        pName: 'PlaceSearch',
                        events: {
                            init(instance) {
                                console.log(instance)
                            }
                        }
                    }
                ]
            }
        },
        props:{
            show:{
                type:Boolean,
                default:true,
            }
        },
        mounted:function(){
            let _this = this;
            _this.amapManager = new AMapManager();
        },
        methods: {
            closeSelf() {
                this.$emit("closeme")
            },
            confirm() {
                if (this.searchKey != '') {
                    var res = {
                        text: this.searchKey,
                        lng: this.lng,
                        lat: this.lat,
                    };
                } else {
                    this.$emit("closeme");
                    return
                }
                this.$emit("closeme", res);
            },
            initSearch() {
                let vm = this
                let map = this.amapManager.getMap()
                AMapUI.loadUI(['misc/PoiPicker'], function(PoiPicker) {
                    var poiPicker = new PoiPicker({
                        input: 'search',
                        placeSearchOptions: {
                            map: map,
                            pageSize: 10
                        },
                        suggestContainer: 'searchTip',
                        searchResultsContainer: 'searchTip'
                    })
                    vm.poiPicker = poiPicker
                    // 监听poi选中信息
                    //搜索框内点击某地址
                    poiPicker.on('poiPicked', function(poiResult) {
                        console.log("poiResult选中",poiResult)
                        let source = poiResult.source
                        let poi = poiResult.item
                        if (source !== 'search') {
                            poiPicker.searchByKeyword(poi.name)
                        } else {
                            poiPicker.clearSearchResults()
                            vm.markers = []
                            let lng = poi.location.lng
                            let lat = poi.location.lat
                            let address = poi.cityname + poi.adname + poi.name
                            //这里给定位到了当前地址
                            let center_map = [lng, lat];
                            if(lng != 0){
                                center_map.lng = vm.lng;
                                center_map.lat = vm.lat;
                            }
                            vm.center = center_map;
                            vm.markers.push(center_map)
                            vm.lng = lng
                            vm.lat = lat
                            vm.address = address
                            vm.searchKey = address
                        }
                    })
                })
            },
            searchByHand() {//搜索按钮点击事件
                if (this.searchKey !== '') {
                    this.poiPicker.searchByKeyword(this.searchKey)
                    console.log(this.searchKey)
                }
            },
            setMapCenter:function(index){

            },
        }
    }
</script>
<style>
    .unload {
        font-size: 14px;
        cursor: pointer;
        width: 100px;
        height: 30px;
        display: block;
        position: relative;
        overflow: hidden;
        border: 1px solid #35d610;
        background: #ebffe6;
        border-radius: 3px;
        text-align: center;
        line-height: 30px;
        color: #666;
        box-sizing: border-box;
        -webkit-box-sizing: border-box;
    }

    .img {
        width: 100%;
        height: 100%;
    }

    .img_document {
        width: 200px;
        background: #f9f9f9;
        margin-bottom: 28px;
        height: 118px;
        border: 1px solid #d4d4d4;
    }

    .modal-backdrop {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0, 0, 0, .3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
    }

    .modal {
        background-color: #fff;
        box-shadow: 0px 0px 23.75px 1.25px rgba(0, 0, 0, 0.2);
        overflow-x: auto;
        display: flex;
        flex-direction: column;
        border-radius: 4px;
        width: 90%;
        height: 85%;
    }

    .modal-header {
        padding: 0 80px 0 20px;
        position: relative;
        height: 40px;
        line-height: 40px;
        border-bottom: 1px solid #e5e5e5;
        font-size: 14px;
        color: #343434;
        background-color: #F8F8F8;
        border-radius: 2px 2px 0 0;
    }

    .modal-header h3 {
        line-height: 40px;
    }

    .modal-footer {
        border-top: 1px solid #eee;
        justify-content: flex-end;
        padding: 15px;
        display: flex;
    }

    .modal-body {
        position: relative;
        height: 100%;
    }

    .btn-close,
    .btn-confirm {
        border-radius: 3px;
        margin-left: 16px;
        width: 60px;
        height: 30px;
        border: none;
        cursor: pointer;
    }

    .btn-close {
        color: #76838f;
        border: 1px solid #e0e6e9;
        background: none;
    }

    .btn-confirm {
        color: #fff;
        background-color: #2d8cf0;
    }

    .container {
        width: 98%;
        height: 98%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate3d(-50%, -50%, 0);
        border: 1px solid #999;
    }

    .search-box {
        position: absolute;
        z-index: 5;
        width: 70%;
        left: 13%;
        top: 10px;
        height: 30px;
    }

    .search-box input {
        float: left;
        width: 80%;
        height: 100%;
        border: 1px solid #2b9bf6;
        padding: 0 8px;
        outline: none;
    }

    .search-box button {
        float: left;
        width: 100px;
        height: 100%;
        background: #2b9bf6;
        border: 1px solid #2b9bf6;
        color: #fff;
        outline: none;
    }

    .tip-box {
        width: 100%;
        max-height: 260px;
        position: absolute;
        top: 30px;
        overflow-y: auto;
        background-color: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/summary/layout/gaode_map.vue